<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  touch-action: manipulation; /* 禁用双击缩放 */
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation; /* 禁用双击缩放 */
  -ms-touch-action: manipulation; /* IE 10+ */
}

#app {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  touch-action: manipulation; /* 禁用双击缩放 */
}

/* 移动端优化 */
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  
  body {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 12px;
  }
  
  body {
    font-size: 12px;
  }
}

/* 触摸优化 */
@media (hover: none) and (pointer: coarse) {
  button,
  a,
  .el-button,
  .el-menu-item {
    min-height: 44px;
    min-width: 44px;
  }
}
</style>
